import { lazy, Suspense, useEffect, type ReactNode } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { hydrateRuntimeContent, startContentAutoRefresh } from './lib/content-runtime';
import { Home } from './pages/Home';

const About = lazy(() => import('./pages/About').then((m) => ({ default: m.About })));
const Gallery = lazy(() => import('./pages/Gallery').then((m) => ({ default: m.Gallery })));
const Commissions = lazy(() =>
  import('./pages/Commissions').then((m) => ({ default: m.Commissions })),
);
const Shows = lazy(() => import('./pages/Shows').then((m) => ({ default: m.Shows })));
const Contact = lazy(() => import('./pages/Contact').then((m) => ({ default: m.Contact })));
const Feedback = lazy(() => import('./pages/Feedback').then((m) => ({ default: m.Feedback })));
const Testimonials = lazy(() =>
  import('./pages/Testimonials').then((m) => ({ default: m.Testimonials })),
);
const Admin = lazy(() => import('./pages/Admin').then((m) => ({ default: m.Admin })));

function PageFallback() {
  return (
    <div className="wrap" style={{ padding: '3rem 0', color: 'var(--ink-soft)' }}>
      Loading…
    </div>
  );
}

function ContentBootstrap({ children }: { children: ReactNode }) {
  useEffect(() => {
    void hydrateRuntimeContent();
    return startContentAutoRefresh(20_000);
  }, []);
  return children;
}

export function App() {
  return (
    <BrowserRouter>
      <ContentBootstrap>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="commissions" element={<Commissions />} />
              <Route path="shows" element={<Shows />} />
              <Route path="charities" element={<Navigate to="/shows" replace />} />
              <Route path="contact" element={<Contact />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="testimonials" element={<Testimonials />} />
              <Route path="admin" element={<Admin />} />
              <Route path="admin/studio" element={<Navigate to="/admin" replace />} />
              <Route path="studio" element={<Navigate to="/admin" replace />} />
              <Route path="originals" element={<Navigate to="/gallery" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </ContentBootstrap>
    </BrowserRouter>
  );
}
